import coin from '../../assets/images/coin.png';
import bills from '../../assets/images/bills.png';
import styles from './DonationRecord.module.css';
import formatNumber from '../../utils/formatNumber.js';
import parseDatetimeText from '../../utils/parseDatetimeText.js';

const DonationRecord = (props) => {
	return (
		<div className={styles.donation}>
			<img className={styles.coin} src={props.donation.type === 'online' ? coin : bills} alt="Coin"/>
			<div>
				<div className={styles.sentence}>
					<span className={styles.name}>
						{props.donation.name ? props.donation.name : 'Anonymous'}
					</span> made a ${formatNumber(props.donation.amount)}{props.donation.type === 'online' ? '' : ' offline'} donation
				</div>
				<div className={styles.datetime}>
					{parseDatetimeText(props.donation.created_at)}
				</div>
			</div>
		</div>
	)
};

export default DonationRecord;